import { Shape } from '@/services/shape';
import {
  addResourceIfNotExists,
  generateLayoutAst,
  insertImages
} from '../utils/resource.utils';
import { RiveAttribute } from '@/services/shape/attributes/rive';
import { buildAstState } from '..';
import { generateResourceName, getRefName } from '../utils/name.utils';

export const getRiveAst = (resourceAst: Ast, shape: Shape) => {
  const {
    x = 0,
    y = 0,
    riveFile = '',
    riveResources = [],
    riveFileExt = '',
    riveResourcesExt = [],
    riveToShow = 'normal',
    resources,
    format,
    recolorEnable
  } = shape.attrs as RiveAttribute;

  // 添加rive file
  let riveAst: Ast = {
    tag: 'File',
    attrsMap: {
      // 二进制里的file名字要加需要加后缀，而且得带路径
      name: generateResourceName(resourceAst, 'File')
    },
    children: []
  };

  // 为app单独添加rive预览图
  if (resources?.rivePreview) {
    const imageMap = insertImages(
      resourceAst,
      {
        rivePreview: resources?.rivePreview
      },
      {
        recolorEnable: !!recolorEnable,
        imgFormat: format
      }
    );
    const previewName = getRefName(imageMap['rivePreview']);
    riveAst.attrsMap.preview = previewName;
  }

  // 如果是编辑器使用
  if (buildAstState.options.buildFor == 'editor') {
    if (riveToShow == 'normal') {
      riveAst.attrsMap.fileName = riveFile;
    } else {
      riveAst.attrsMap.fileNameExt = riveFileExt;
    }
    riveAst = addResourceIfNotExists(resourceAst, riveAst, undefined, true);
  } else {
    riveAst.attrsMap.fileName = riveFile;

    // 如果存在高级特性的rive，添加到fileNameExt中
    if (riveFileExt && buildAstState.data.description?.watchOS == 'android') {
      riveAst.attrsMap.fileNameExt = riveFileExt;
    }

    riveAst = addResourceIfNotExists(resourceAst, riveAst, undefined, true);

    // 添加rive resources
    [...riveResources, ...riveResourcesExt].forEach((item) => {
      const name = item;
      const ast: Ast = {
        tag: 'File',
        attrsMap: {
          name,
          fileName: name
        },
        children: []
      };
      addResourceIfNotExists(resourceAst, ast, undefined, true);
    });
  }

  // 生成 layout ast
  const layoutAst: Ast = generateLayoutAst({
    ref: '@' + riveAst.attrsMap.name,
    x,
    y
  });

  return layoutAst;
};
